let configuredBaseURL: string = process.env.REACT_APP_API_BASE_URL || "";

export function setDesignControlsBaseURL(url: string): void {
  configuredBaseURL = url;
}

export function getDesignControlsBaseURL(): string {
  return configuredBaseURL;
}
